var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./name-first-last.j2"] = require( "./name-first-last.j2" );
dependencies["./address-1.j2"] = require( "./address-1.j2" );
dependencies["./address-2.j2"] = require( "./address-2.j2" );
dependencies["./city.j2"] = require( "./city.j2" );
dependencies["./region.j2"] = require( "./region.j2" );
dependencies["./postcode.j2"] = require( "./postcode.j2" );
dependencies["./phone.j2"] = require( "./phone.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/address-form-group4.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"o-row\">\n\n    ";
env.getTemplate("./name-first-last.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n</div>\n\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__address-1 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./address-1.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n    </div>\n\n</div>\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__address-2 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./address-2.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n    </div>\n\n</div>\n\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__city g-address-payment__city--group-4 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./city.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n    </div>\n\n</div>\n\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__region--group-4 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./region.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n    </div>\n\n</div>\n\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__postcode--group-4 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit-adjacent-last":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./postcode.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n\n    </div>\n\n</div>\n\n\n<div class=\"o-row\">\n\n    <div class=\"g-address-payment__phone ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"editAddress")?"g-address-payment--edit":""), env.opts.autoescape);
output += "\">\n\n        ";
env.getTemplate("./phone.j2", false, "account/templates/partials/address-form/address-form-group4.j2", null, function(t_27,t_25) {
if(t_27) { cb(t_27); return; }
t_25.render(context.getVariables(), frame, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
output += t_26
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/address-form-group4.j2"] , dependencies)